import tw from 'twin.macro';

const ErrorMessage = tw.div`text-red-400 text-sm px-2 py-1 bg-red-100 border-red-200 border-l-4 inline-block`;

export default ErrorMessage;
